import React, { useEffect, createElement } from 'react';
import { Hero } from './components/Hero';
import { DeliveryBullets } from './components/DeliveryBullets';
import { ShortTestimonials } from './components/ShortTestimonials';
import { HiddenCost } from './components/HiddenCost';
import { Tomos } from './components/Tomos';
import { Bonuses } from './components/Bonuses';
import { ProKit } from './components/ProKit';
import { PricingCards } from './components/PricingCards';
import { Guarantee } from './components/Guarantee';
import { FAQ } from './components/FAQ';
import { Closing } from './components/Closing';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { SocialProofPopup } from './components/SocialProofPopup';
export function App() {
  useEffect(() => {
    // Meta Pixel
    const script = document.createElement('script');
    script.innerHTML = `
      !function(f,b,e,v,n,t,s)
      {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
      n.callMethod.apply(n,arguments):n.queue.push(arguments)};
      if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
      n.queue=[];t=b.createElement(e);t.async=!0;
      t.src=v;s=b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t,s)}(window,document,'script',
      'https://connect.facebook.net/en_US/fbevents.js');
      fbq('init', '794641966815768');
      fbq('track', 'PageView');
    `;
    document.head.appendChild(script);
    const noscript = document.createElement('noscript');
    const img = document.createElement('img');
    img.height = 1;
    img.width = 1;
    img.style.display = 'none';
    img.src = 'https://www.facebook.com/tr?id=794641966815768&ev=PageView&noscript=1';
    noscript.appendChild(img);
    document.body.appendChild(noscript);
    return () => {
      document.head.removeChild(script);
      document.body.removeChild(noscript);
    };
  }, []);
  return <div className="w-full min-h-screen relative bg-[#16101F] text-white overflow-hidden" data-id="element-0">
      <SocialProofPopup data-id="element-1" />

      <div className="fixed inset-0 pointer-events-none z-0" style={{
      background: 'radial-gradient(ellipse 80% 60% at 50% 50%, rgba(192, 132, 252, 0.18) 0%, rgba(192, 132, 252, 0.10) 35%, rgba(192, 132, 252, 0.04) 60%, rgba(22, 16, 31, 0) 85%)'
    }} data-id="element-2" />

      <div className="relative z-10" data-id="element-3">
        <Hero data-id="element-4" />
        <DeliveryBullets data-id="element-5" />
        <HiddenCost data-id="element-6" />
        <Tomos data-id="element-7" />
        <ProKit data-id="element-8" />
        <Bonuses data-id="element-9" />
        <PricingCards data-id="element-10" />
        <ShortTestimonials data-id="element-11" />
        <Guarantee data-id="element-12" />
        <FAQ data-id="element-13" />
        <Closing data-id="element-14" />
        <FinalCTA data-id="element-15" />
        <Footer data-id="element-16" />
      </div>
    </div>;
}